import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Spinner/Spinner';
import { cn } from '../../cn';
import { BUTTON_SIZES, BUTTON_VARIANTS } from '../../constants';

const Button = forwardRef(({
  children,
  variant = 'primary',
  size = 'md',
  shape = 'rounded',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}, ref) => {
  const classes = cn(
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    shape === 'square' && 'btn-square',
    disabled && 'btn-muted',
    className
  );

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && <Spinner size="sm" color="white" className="-ml-1 mr-2" />}
      {children}
    </button>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  size: PropTypes.oneOf(BUTTON_SIZES),
  shape: PropTypes.oneOf(['rounded', 'square']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string
};

export default Button;
